"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUsageAndQuota = getUsageAndQuota;
exports.clearDataForOrigin = clearDataForOrigin;
exports.getTrustTokens = getTrustTokens;
exports.getStorageKeyForFrame = getStorageKeyForFrame;
exports.getSharedStorageMetadata = getSharedStorageMetadata;
exports.setStorageBucketTracking = setStorageBucketTracking;
var each_1 = __importDefault(require("licia/each"));
var rmCookie_1 = __importDefault(require("licia/rmCookie"));
var safeStorage_1 = __importDefault(require("licia/safeStorage"));
var connector_1 = __importDefault(require("../lib/connector"));
var Network_1 = require("./Network");
var localStore = (0, safeStorage_1.default)('local');
var sessionStore = (0, safeStorage_1.default)('session');
function getUsageAndQuota() {
    return {
        quota: 0,
        usage: 0,
        overrideActive: false,
        usageBreakdown: [],
    };
}
function clearDataForOrigin(params) {
    var storageTypes = params.storageTypes.split(',');
    (0, each_1.default)(storageTypes, function (type) {
        if (type === 'cookies') {
            var cookies = (0, Network_1.getCookies)().cookies;
            (0, each_1.default)(cookies, function (_a) {
                var name = _a.name;
                return (0, rmCookie_1.default)(name);
            });
        }
        else if (type === 'local_storage') {
            localStore.clear();
            sessionStore.clear();
        }
    });
}
function getTrustTokens() {
    return {
        tokens: [],
    };
}
function getStorageKeyForFrame() {
    return {
        storageKey: location.origin,
    };
}
function getSharedStorageMetadata() {
    return {
        metadata: {
            creationTime: 0,
            length: 0,
            remainingBudget: 0,
            bytesUsed: 0,
        },
    };
}
function setStorageBucketTracking() {
    connector_1.default.trigger('Storage.storageBucketCreatedOrUpdated', {
        bucketInfo: {
            bucket: {
                storageKey: location.origin,
            },
            durability: 'relaxed',
            expiration: 0,
            id: '0',
            persistent: false,
            quota: 0,
        },
    });
}
